/* Every asset the site serves lives on the Modulify CDN, not in the repo.
   Nothing is stored in `public/` any more, so a path like `/images/hero.jpg`
   will 404 — always reference an asset through this file.

   The base is written as a literal on purpose. `process.env.CDN_URL` is
   server-side only, so reading it from a client component would leave the URL
   undefined in the browser and cause a hydration mismatch. This constant is
   safe on both sides.

   To add an asset: upload it to storage under the matching prefix
   (`brand/`, `images/site/`, `images/services/`, `images/projects/`,
   `images/process/`), then add it here. Reuse the same key to replace a file
   in place; the CDN cache is purged automatically, so never append `?v=`. */
export const CDN_BASE = 'https://capitalcraftconstruction.cdn.modulify.website'

export const cdn = (key: string): string => `${CDN_BASE}/${key.replace(/^\/+/, '')}`

/* Brand marks. The lockup is used exactly as supplied — never redrawn. */
export const brandAssets = {
    logoFullSvg: cdn('brand/ccc-logo-full.svg'),
    logoFullPng: cdn('brand/ccc-logo-full.png'),
    logoMarkSvg: cdn('brand/ccc-logo.svg'),
    monogramPng: cdn('brand/ccc-mark.png'),
    favicon: cdn('brand/favicon.svg')
}

/* Photography that is part of the design rather than CMS content. Anything a
   user can change belongs in the CMS, which already stores absolute CDN URLs. */
export const siteImages = {
    hero: cdn('images/site/hero-home-extension.png'),
    homeLoftProject: cdn('images/process/brockley-loft-steels-and-joists.jpg'),
    homeRenovations: cdn('images/site/home-renovations.jpg'),
    whyWeStarted: cdn('images/site/why-we-started.jpg'),
    timberFrame: cdn('images/site/about-timber-frame.png'),
    brickwork: cdn('images/site/craft-brickwork.jpg')
}

/* Self-hosted typefaces, declared as @font-face in `globals.css`. */
export const fontAssets = {
    archivoVariable: cdn('fonts/archivo-variable.woff2'),
    archivoVariableLatinExt: cdn('fonts/archivo-variable-latin-ext.woff2'),
    plexMono400: cdn('fonts/ibm-plex-mono-400.woff2'),
    plexMono500: cdn('fonts/ibm-plex-mono-500.woff2'),
    plexMono600: cdn('fonts/ibm-plex-mono-600.woff2')
}
